export const getScaledQuantity = (quantity, baseServings, currentServings) => {
    if (!quantity) return "";
    const base = baseServings || 2;
    const scaled = (quantity / base) * currentServings;
    return Number.isInteger(scaled) ? scaled : scaled.toFixed(1).replace('.0', '');
};

export const findStepMedia = (mediaList, step) => {
    if (!mediaList || !step) return undefined;
    return mediaList.find(m => {
        if (m.isHeroShot) return false;
        if (step.id && m.stepId && String(m.stepId) === String(step.id)) return true;
        const sNum = step.stepNumber || step.step_number;
        const mNum = m.stepNumber || m.step_number;
        if (sNum && mNum && Number(sNum) === Number(mNum)) return true;
        return false;
    });
};

export const findStepIngredients = (ingredientsList, step) => {
    if (!ingredientsList || !step) return [];
    return ingredientsList.filter(i => {
        if (step.stepNumber && i.stepNumber === step.stepNumber) return true;
        if (step.id && i.stepId === step.id) return true;
        return false;
    });
};
